<template>
  <div id="channel-sidebar" class="py3 pl2" @click="scrollToVideos()">
    <ul v-if="isVisible('channels')" class="m0">
      <li class="channel" v-for="channel in channels" :key="channel.id">
        <router-link :to='channelLink(channel)'>
          {{ channel.name }}
        </router-link>
        <ul v-if="channel.subchannels.length > 1" class="subchannels ml2">
          <li v-for="subchannel
            in channel.subchannels"
            :key="subchannel.id">
            <router-link class="block" :to='subChannelLink(channel, subchannel)'>
              {{ subchannel.name }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
    <ul v-else-if="!showAllThemes" class="m0">
      <li v-for="theme in themes" :key="theme.id">
        <router-link :to='themeLink(theme)'>{{ theme.name }}</router-link>
      </li>
      <li v-if="!showAllThemes" class="mt3 pointer" @click="showAllThemes = true">All Themes...</li>
    </ul>
    <ul v-else id="all-themes">
      <li v-for="theme in allThemes" :key="theme.id">
        <router-link :to='themeLink(theme)'>{{ theme.name }}</router-link>
      </li>
    </ul>
    <div id="sort">
      <div @click="sortVideosByDate()" class="mt3 pointer noselect"
        :class="{ active: sortBy === 'date' }">
      <span v-if="sortBy === 'date'" class="green">
        <span v-if="asc">▽</span>
        <span v-else="">△</span>
      </span> Date</div>
    <div @click="sortVideosByDuration()" class="pointer noselect"
      :class="{ active: sortBy === 'duration' }">
      <span v-if="sortBy === 'duration'" class="green">
        <span v-if="asc">▽</span>
        <span v-else="">△</span>
      </span> Duration</div>
    <div @click="sortVideosByTitle()" class="pointer noselect"
      :class="{ active: sortBy === 'title' }">
      <span v-if="sortBy === 'title'" class="green">
        <span v-if="asc">▽</span>
        <span v-else="">△</span>
      </span> Title</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {

  name: 'VideosSidebar',

  data () {
    return {
      showAllThemes: false
    }
  },

  computed: {
    ...mapState([
      'channels',
      'themes',
      'allThemes',
      'asc',
      'sortBy'
    ])
  },

  methods: {
    ...mapActions([
      'sortVideosByDuration',
      'sortVideosByDate',
      'sortVideosByTitle',
      'getAllThemes'
    ]),
    channelLink: function (channel) {
      return '/channels/' + channel.slug + this.$route.hash
    },
    subChannelLink: function (channel, subchannel) {
      return '/channels/' + channel.slug + '/' + subchannel.slug + this.$route.hash
    },
    themeLink: function (theme) {
      return '/themes/' + theme.slug + this.$route.hash
    },
    isVisible: function (name) {
      if (this.$route.name === 'Channels' || this.$route.fullPath.includes('/channels')) {
        return name === 'channels'
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="css" scoped>
  #all-themes {
    max-height: 50vh;
    overflow-y: scroll;
  }

  #channel-sidebar {
    font-size: var(--font-size-large);
    line-height: 1.6;
    position: sticky;
  }

  a.router-link-active {
    color: var(--color-green);
  }

  .channel {
    .subchannels {
      display: none;
    }

    a.router-link-active+.subchannels {
      display: block;
    }
  }

  #sort {
    &>div {
      opacity: 0.15;

      &.active, &:hover {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VideosSidebar.vue